import ThemedBlock from 'components/atoms/ThemedBlock'
import i18n from 'utils/i18n'
import Form, { createTranslationField } from 'components/molecules/Form'
import { FormFieldsConstants } from 'utils/constants/form-constants';
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import React, { useState } from 'react'
import HelperString from 'utils/helper-string'
import _ from 'lodash'
import Translate from 'utils/translate'
import { dataConstants } from 'services/redux/data/constants'
import { useSelector } from 'react-redux'
import ThemedImagePicker from 'components/management/molecules/ThemedImagePicker'
import HelperManagementBuilding, { BUILDING_UPLOAD_TYPE } from 'utils/helper/management/HelperManagementBuilding'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'

const BuildingData = ({ building, saveForm }) => {
	
	const [ formKey, setFormKey ] = useState( HelperString.random() )
	
	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	
	const [ uploading, setUploading ] = useState( false )
	const [ buildingImage, setBuildingImage ] = useState( null )
	
	const onSelectImage = ( data ) => {
		const { base64 } = data;
		
		HelperManagementBuilding.uploadImage( base64, BUILDING_UPLOAD_TYPE.BUILDING, building.guid, {
			onStart: () => {
				setUploading( true )
			},
			onSuccess: result => {
				setBuildingImage( result.photo_url )
				setUploading( false )
			},
			onError: result => {
				setUploading( false )
			}
		});
	}
	
	// Create the default form values
	const formFields = [
		{
			name: 'name',
			required: true,
			label: i18n.t('management:form.name.title'),
			type: FormFieldsConstants.TEXT,
		},
		{
			name: 'available_for',
			required: true,
			label: i18n.t('management:form.available_for.short'),
			type: FormFieldsConstants.SELECT_AVAILABLE_FOR,
		},
		{
			name: 'aed',
			required: true,
			label: i18n.t('management:form.aed.title'),
			hint: i18n.t('management:form.aed.description'),
			type: FormFieldsConstants.SELECT_ACTIVE,
		},
		{
			name: 'address_postal_code',
			required: false,
			label: i18n.t('management:form.address_postal_code.title'),
			hint: i18n.t('management:form.address_postal_code.description'),
			type: FormFieldsConstants.ADDRESS,
			props: {
				maxLength: 50,
				filter: 'none',
			}
		},
		{
			name: 'active',
			required: true,
			label: i18n.t('management:form.active.title'),
			type: FormFieldsConstants.SELECT_ACTIVE
		}
	]
	
	// Add the translations
	if( _.size( _languages ) > 0 ) {
		formFields.push( {
			type: FormFieldsConstants.DIVIDER
		} );
		
		// Add the translation fields
		_.forEach( _languages, ( language ) => {
			_.forEach( { name: 'title', description: 'description' }, ( field, formName ) => {
				const { name, formField } = createTranslationField( formName, language );
				
				formFields.push( formField );
				
				const translation = Translate.formField( building, field, language );
				if( translation !== null ) {
					building[ name ] = translation;
				}
			})
		})
	}
	
	return (
		<VStack
			space={ ThemedValues.stackSpace }>
		
			<ThemedBlock
				header={ i18n.t('management:form_block.title_default') }
				shadow
				mediumPadding>
				
				<Form
					key={ HelperString.hash( 'form', formKey ) }
					values={{
						...building,
						address_postal_code: _.get( building, ['address', 'name'] ),
					}}
					fields={ formFields }
					onSubmit={ saveForm }
					disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.BUILDINGS ) }
				/>
			</ThemedBlock>
			
			<ThemedBlock
				header={ i18n.t('management:form_block.title_image') }
				shadow
				mediumPadding>
				
				<ThemedImagePicker
					source={ buildingImage ?? building?.photo_url }
					onSelect={ onSelectImage }
					loading={ uploading }
				/>
			</ThemedBlock>
		</VStack>
	);
}

export default BuildingData
